import IconClients from '@apollo/icons/default/IconClients.svg';
import {
  Button,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { ClientFilter } from 'src/components/clientFilter/ClientFilter';
interface Props {
  graphId: string;
  canViewVersions: boolean;
  clientFilterCount?: number;
}

export const ClientFilterPopover = ({
  graphId,
  canViewVersions,
  clientFilterCount,
}: Props) => {
  const initialFocusRef = React.useRef(null);

  return (
    <Popover
      closeOnEsc
      placement="bottom-start"
      initialFocusRef={initialFocusRef}
      returnFocusOnClose={false}
      isLazy={true}
    >
      <PopoverTrigger>
        <Button
          variant="hidden"
          className="ml-2"
          aria-label="Filter by Clients"
          leftIcon={
            <span>
              <IconClients />
              <div
                className={classnames(
                  'absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-notice px-1 text-[12px] font-semibold text-inverted',
                  {
                    hidden: !clientFilterCount || clientFilterCount === 0,
                  },
                )}
              >
                {clientFilterCount && clientFilterCount > 99 ? (
                  <p>99+</p>
                ) : (
                  clientFilterCount
                )}
              </div>
            </span>
          }
        />
      </PopoverTrigger>
      {/**
       * Wrapper div w/z-index is required to prevent pagination controls
       * from overlapping the popover
       */}
      <div className="z-30">
        <PopoverContent className="w-[28rem]">
          <PopoverBody className="max-h-[calc(100vh-256px)] overflow-y-auto p-0">
            <ClientFilter
              title="Clients"
              canViewVersions={canViewVersions}
              serviceId={graphId}
              clientThresholdToShowSearch={10}
              showReset
              ref={initialFocusRef}
            />
          </PopoverBody>
        </PopoverContent>
      </div>
    </Popover>
  );
};
